/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Box, Button, FlexContainer, Text, theme } from "@nordcloud/gnui";

type Props = {
  children: React.ReactNode;
  label: string;
  onClick: () => void;
  deletable: boolean;
};

const border = `1px solid ${theme.color.border.border01}`;

export function ListItem({
  children,
  label,
  onClick,
  deletable = true,
}: Props) {
  return (
    <li
      data-testid="rule-match"
      css={{
        marginBottom: theme.spacing.spacing01,
      }}
    >
      <Box
        boxStyle="lightGrey"
        padding={theme.spacing.spacing00}
        innerSpacing="spacing02"
      >
        <div
          css={{
            borderBottom: border,
            padding: theme.spacing.spacing02,
          }}
        >
          <FlexContainer justifyContent="space-between">
            <Text tag="div" weight="medium">
              {label}
            </Text>
            {deletable && (
              <Button icon="trash" size="md" severity="low" onClick={onClick} />
            )}
          </FlexContainer>
        </div>
        {children}
      </Box>
    </li>
  );
}
